// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import "swiper/css/swiper.min.css";
import 'font-awesome/css/font-awesome.css'
import 'mint-ui/lib/style.css'
import components from './components'
//Mock.start();
import store from './store/index'
import axios from 'axios';
import Mint from 'mint-ui';
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad, {
  preLoad: 1.3,
  error: 'http://www.yuanwhite.com/app/img/static/loading.png',
  loading: 'http://www.yuanwhite.com/app/img/static/loading.png',
  attempt: 1
})
Vue.prototype.$axios = axios
Vue.use(Mint);
Vue.use(ElementUI);
Vue.use(components);
Vue.config.productionTip = false


router.afterEach((to, from, next) => {
  //进入页面默认在顶部

  window.scrollTo(0, 0)

})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js